<template>
  <header>
    <router-link to="/" class="logo" id="Logo">
      <div v-bind:class="{ invertedView: $route.meta.inverted }">
        <img src="/img/logo.png" alt="AMA" class="invLogo" />
        <img src="/img/logo_inv.png" alt="AMA" />
      </div>
    </router-link>
    <div class="screenMenu">
      <router-link to="/projekty">projekty</router-link>
      <router-link to="/oferta">oferta</router-link>
      <router-link to="/pracownia">pracownia</router-link>
      <router-link to="/kontakt">kontakt</router-link>
      <div class="social-icons">
        <a
          href="https://www.instagram.com/annamillerarchitekci"
          target="_blank"
          class="social-icon"
          rel="nofollow"
        >
          <div class="instagram-logo" v-bind:class="{ invertedIcon: $route.meta.inverted }"></div>
        </a>
        <a
          href="https://pl.linkedin.com/in/annamillerarchitekt"
          target="_blank"
          class="social-icon"
          rel="nofollow"
        >
          <div class="linkedin-logo" v-bind:class="{ invertedIcon: $route.meta.inverted }"></div>
        </a>
      </div>
    </div>
  </header>
</template>
<script>
import FixedHeader from "vue-fixed-header";
import { mapGetters, mapActions } from "vuex";
let Config = require("../app.config.js");
const fetchInitialData = store => {
  return store.dispatch(`menu/getMenu`, "menu_main");
};
export default {
  name: "app-header",
  components: {
    FixedHeader
  },
  data: () => {
    return {
      isActive: false,
      isMenuActive: false,
      ayContrast: false,
      siteName: ""
    };
  },
  prefetch: fetchInitialData,
  computed: {
    ...mapGetters("menu", ["menuItems", "testIt"])
  },
  methods: {
    changeUrl(url) {
      return url.replace(Config.wpDomain, "/");
    },
    ...mapActions("menu", {
      getMenu: "getMenu"
    }),
    toggleMenu() {
      this.isActive = !this.isActive;
    },
    closeMenu() {
      this.isMenuActive = false;
    },
    relativePath(url) {
      url = url.replace("https://", "");
      var domain = url.split("/")[0];
      return url.replace(domain, "");
    },
    loadData() {
      fetchInitialData(this.$store);
    }
  },
  mounted() {
    window.onscroll = function() {
      growShrinkLogo();
    };

    function growShrinkLogo() {
      var pageContainer = document.getElementById("page");
      var Logo = document.getElementById("Logo");
      if (
        document.body.scrollTop > 5 ||
        document.documentElement.scrollTop > 5
      ) {
        Logo.classList.add("moved");
        pageContainer.classList.add("moved");
      } else {
        Logo.classList.remove("moved");
        pageContainer.classList.remove("moved");
      }
    }
  }
};
</script>
<style lang="scss">
.fadex-leave {
  transition-duration: 0.9s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}

.fadex-enter {
  opacity: 0;
}

@media only screen and (max-width: 768px) {
  #page div.header-container {
    background-image: none;
  }
  .header-container .main-navigation {
    text-align: center;
    padding: 25px 0 0;
  }
  .main-navigation > .menu > li > ul.sub-menu {
    margin-left: 0;
    li {
      background: none !important;
      border: 0 !important;
    }
    a {
      text-indent: 0;
    }
  }
  #primary-menu.active {
    a {
      padding: 3px;
    }
    display: block;
    li a {
      text-align: center;
    }
    a:after {
      content: none;
    }
    ul {
      display: block;
      padding-top: 0;
    }
  }
  .vue-fixed-header--isFixed {
    ul#primary-menu {
      margin-top: 60px;
      background-color: rgba(61, 22, 56, 0.88);
      & > li > a,
      a {
        color: #fff;
      }
    }
  }
}
.menu-toggle {
  color: #fff;
}

.vue-fixed-header--isFixed {
  border-bottom: 1px solid #ccc;
  .menu-toggle {
    float: right;
    color: #000;
  }
}
#amaBackground {
  width: 100%;
  background: url("/img/0.svg") no-repeat center center;
}
#Logo {
  font-size: 0;
  transition: all 0.3s ease;
}
#Logo img {
  height: 157px;
  transition: height 0.3s ease;
}

@media (max-width: 768px) {
  #Logo img {
    width: 30%;
    margin-left: 20px;
    margin-top: -20px;
    height: auto;
  }
  #Logo.moved {
    margin: 0 auto;
  }
}
@media (max-width: 420px) {
  #Logo img {
    width: 50%;
    margin-left: 0;
    height: auto;
  }
}
#Logo > div {
  position: relative;
}

#Logo img {
  -webkit-transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -o-transition: opacity 1s ease-in-out;
  transition: opacity 1s ease-in-out;
}
.invLogo {
  position: absolute;
  left: 0;
}

.invertedView {
  .invLogo {
    opacity: 0;
  }
}
.invertedHeader {
  .social-icon {
    .invLogo {
      opacity: 0;
    }
  }
}
// .social-icon {
//   transition: all 0.3s ease-in-out;
//   position: relative;
//   &:hover {
//     // opacity: 0.5;
//   }
// }
</style>
